import {
    login, password, 
    adressStandList, adressStands, 
    adressColorsStand, adressSinks, 
    adressTabletops, adressTabletopsColor, 
    adressFlapVariation, adressFlaps, 
    addressDefaultConfig, adressMirrors, 
    addressMirrorsList, adressCabinets,
    adressCabinetList, adressSinksId,
    adressRender} from '../utils/constants';


let credentials = btoa(`${login}:${password}`);

export class ConstructorApi{
    constructor(){
        this._login = login;
        this._password = password;
    }

    getStands() {
        return fetch(`${adressStands}`,{
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }
    
    getStandsList(fileName) {
        return fetch(`${adressStandList + `${fileName}`}`,{
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getStandsColor() {
        return fetch(`${adressColorsStand}`,{
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getSinks() {
        return fetch(`${adressSinks}`,{
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }
    
    getSinksId() {
        return fetch(`${adressSinksId}`,{
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getFlapVariations() {
        return fetch(`${adressFlapVariation}`,{
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getFlaps() {
        return fetch(`${adressFlaps}`,{
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getTabletops() {
        return fetch(`${adressTabletops}`, {
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getTabletopsColors() {
        return fetch(`${adressTabletopsColor}`, {
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getDefaultConfig() {
        return fetch(`${addressDefaultConfig}`, {
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getMirrors() {
        return fetch(`${adressMirrors}`,{
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getMirrorsList(fileName) {
        return fetch(`${addressMirrorsList}${fileName}`, {
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getCabinets() {
        return fetch(`${adressCabinets}`, {
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }

    getCabinetList(fileName) {
        return fetch(`${adressCabinetList}/${fileName}`, {
            method: 'GET',
            headers:{
                Authorization: 'Basic ' + credentials
            }
        })
        .then(res => {
            return this._getResponseData(res);
        })
    }
    
    postRender(param) {
        const obj = {
            bg: "barno", 
            stand: "barno",
            standMaterial: "CM-90",
            sink: "Forma",
            cutout: false,
            sinkPosition:  "C",
            sinkCountCup:  1,
            sinkHeight:  12,
            tabletop: "SolidSurface12",
            tabletopPosition: "C",
            mirror: "Bell",
            mirrorMaterial:  "CH-01",
            cabinet:  "BarnoPenal",
            cabinetMaterial:  "CM-90"
        }
        const jsonObj = JSON.stringify(param)
        return fetch(`${adressRender}`, {
            method: 'POST',
            headers:{
                Authorization: 'Basic ' + credentials
            },
            body: jsonObj,

        })
        .then(res => {
            return this._getResponseData(res);
        })
    }


    _getResponseData(res) {
        if (!res.ok) {
            return Promise.reject(`Ошибка: ${res.status}`);
        }
        return res.json();
    }
}

const apiConstructor = new ConstructorApi(login, password);

export {apiConstructor};